import { render, staticRenderFns } from "./distributionManage.vue?vue&type=template&id=67530f38&"
import script from "./distributionManage.vue?vue&type=script&lang=js&"
export * from "./distributionManage.vue?vue&type=script&lang=js&"
import style0 from "./distributionManage.vue?vue&type=style&index=0&id=67530f38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports